import React from "react";

import ImportExportMenu from "Components/Common/DataImport/ImportExportMenu";
import { DataImportConfig } from "Components/Common/DataImport/dataImportFields";
import {
  exportLTATypesToCSV,
  importLTAType,
} from "common/services/ltas.service";

const importConfig: DataImportConfig = {
  title: "LTA Types",
  entityLabel: "LTA type",
  icon: "ri-file-list-3-line",
  templateFile: "lta_types_import_template.csv",
  importFn: importLTAType,
  fields: [
    {
      key: "name",
      label: "Name",
      required: true,
      hint: "Must be unique across LTA types",
    },
    { key: "description", label: "Description" },
  ],
};

/** Import/export menu for the LTA types table. */
const Import = ({ apiParams }: { apiParams?: any }) => (
  <ImportExportMenu
    resource="lta-type"
    config={importConfig}
    exportFn={exportLTATypesToCSV}
    exportFileName="LTA_Types_Export.csv"
    apiParams={apiParams}
  />
);

export default Import;
